import script from "./Cursor.vue?vue&type=script&setup=true&lang=js"
export * from "./Cursor.vue?vue&type=script&setup=true&lang=js"

import "./Cursor.vue?vue&type=style&index=0&id=1400ae18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1400ae18"]])

export default __exports__